import * as angular from "angular";
import {IController, IOnChangesObject, IScope} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {LocationModel} from "../../../commons/models/location.model";
import {$agentFactory} from "../../$agent.factory";

export class AgentListItinerariesItemCtrl implements IController {

  agentId: string;
  isSelected: any;
  isItineraryMode: any;
  enableDriverButton: any;
  enableItineraryButton: any;
  enableChangeDriverStatus: boolean;
  isMinimizedData: boolean;

  onChangeStatus: Function;
  onItineraryClick: Function;
  onAgentSelect: Function;

  private agent: AgentModel;
  public lastKnownLocation: LocationModel;
  private agentRef: any;
  private agentLocationRef: any;

  constructor(private $agent: $agentFactory, private $scope: IScope) {
  }

  $onInit() {
    if (this.agentId) {
      this.agentRef = this.$agent(this.agentId);
      this.agentRef.$bindCtrlToId(this.$scope, this, 'agent', 'agentId');
    }
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.agentId && !changes.agentId.isFirstChange()) {
      this.$onInit();
    }
  };
}

angular
  .module('bringoz.admin.agents')
  .component('agentListItinerariesItem', {
    bindings: {
      agentId: '<',
      isSelected: '<',
      isItineraryMode: '<?',
      enableDriverButton: '<?',
      enableItineraryButton: '<?',
      enableChangeDriverStatus: '<?',
      isMinimizedData: '<?',
      onChangeStatus: '&',
      onItineraryClick: '&',
      onAgentSelect: '&'
    },
    template: require('./agent-list-itineraries-item.html').default,
    controller: AgentListItinerariesItemCtrl
  });
